import React from "react"

const Form = ({ iframeHeight }) => {
  return (
    <iframe src="/form.html" frameBorder="0" width="100%" height={iframeHeight} border="0" loading="lazy"></iframe>
  )
}

export default Form
